import {GET, POST} from "@/services/gateway";

export const listSeats = ({pagination, search}) => {
  return POST('salesforce/user/list', {pagination, search})
}

export const refresh = () => {
  return GET('salesforce/users/refresh');
}

export const exportSnapshot = (search, pagination) => {
  const currentDate = new Date();

  return POST('salesforce/seats/export', {search, pagination, TimeZoneOffset: currentDate.getTimezoneOffset()})
}
